import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const CallbackStyles = makeStyles((theme: Theme) => ({
  main: { display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 50 },
  prevRoutes: {
    color: theme.palette.primary.main,
  },
  buttonParent: {
    display: 'flex',
    flexDirection: 'column',
  },
  error: {
    color: theme.palette.error.main,
    fontSize: 20,
  },
}));

export const BaseStyles = makeStyles((theme: Theme) => ({
  button: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    padding: '6px 16px 6px 12px',
  },
  icon: {
    maringRight: 2,
    paddingRight: 4,
    marginBottom: 4,
    color: theme.palette.secondary.main,
  },
}));
